module.exports = __webpack_public_path__ + "media/images/apple_health/watch-4623d36a48e45aa6d9908edd00648dfd.svg";